exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#replace-asset-dropzone[data-v-021b5952]{min-height:126px}#replace-asset-add-files[data-v-021b5952]{padding-top:45px}.dz-uploaded-file[data-v-021b5952]{cursor:default}.dz-uploaded-file .dz-upload-info[data-v-021b5952]{left:160px}.dz-uploaded-file .dz-progress[data-v-021b5952]{width:calc(100% - 172px)}.dz-uploaded-file .dz-filename.xlg[data-v-021b5952]{height:82px;max-height:82px}.dz-uploaded-file .dz-upload-info.xlg[data-v-021b5952]{left:8px}.dz-uploaded-file .dz-progress.xlg[data-v-021b5952]{width:calc(100% - 24px)}", ""]);

// exports
